import { render } from "./ClassGrowthRecord.vue?vue&type=template&id=9aef4624&scoped=true&ts=true"
import script from "./ClassGrowthRecord.vue?vue&type=script&lang=ts"
export * from "./ClassGrowthRecord.vue?vue&type=script&lang=ts"

import "./ClassGrowthRecord.vue?vue&type=style&index=0&id=9aef4624&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aef4624"]])

export default __exports__